import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/index.js'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue')
  },
  {
    path: '/gallery',
    name: 'Gallery',
    component: () => import('../views/Gallery.vue')
  },
  {
    path: '/inspiration/:id',
    name: 'InspirationDetail',
    component: () => import('../views/InspirationDetail.vue')
  },
  {
    path: '/models',
    name: 'Models',
    component: () => import('../views/Models.vue')
  },
  {
    path: '/history',
    name: 'History',
    component: () => import('../views/History.vue')
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import('../views/Profile.vue')
  },
  {
    path: '/credits',
    name: 'Credits',
    component: () => import('../views/Credits.vue')
  },
  {
    path: '/collections',
    name: 'MyCollections',
    component: () => import('../views/MyCollections.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach(async (to, from, next) => {
  const publicPages = ['/', '/gallery', '/models']
  const authRequired = !publicPages.includes(to.path)
  const token = localStorage.getItem('sb-access-token')

  if (authRequired && !token) {
    // 打开认证弹框，然后取消导航
    store.commit('SET_AUTH_DIALOG', true)
    return next(false)
  }
  next()
})

// 每次切换页面或刷新后刷新余额，保持 NavBar 显示最新
router.afterEach(function () {
  if (localStorage.getItem('sb-access-token')) {
    store.dispatch('fetchCredits')
  }
})

export default router
